import { parsePhoneNumber } from 'libphonenumber-js';

export default [() => {
  return (input) => {
    try {
      const phoneNumber = parsePhoneNumber(input);
      return phoneNumber.formatInternational();
    } catch (e) {
      return input
    }
  }
}]
